import React from 'react';
import {
  AccountDto,
  useAccountsControllerAddEmailMutation,
  useAccountsControllerGetAccountsQuery,
  useAccountsControllerRemoveMutation,
  useAccountsControllerSetPrimaryMutation,
} from '@/store/services/MidleNestApi.service';
import { errorHandler } from '@/utils/error.handler';
import {
  ErrorArea,
  Form,
  Input,
  ReformSetError,
  ReformSubmitHandler,
  Submit,
} from '@kodkafa/reform';
import { Trans, useTranslation } from 'react-i18next';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ActionButtonHandler } from '@/components/shared/action-button/ActionButton.component';
import { Loader } from '@/components';
import { ActionButton } from '@/components/shared/action-button';
import { useProfile } from '@/hooks';

export function ChangeEmailView() {
  const { t } = useTranslation();
  const { profile } = useProfile();

  const { data, isLoading } = useAccountsControllerGetAccountsQuery('email');
  const [addEmail] = useAccountsControllerAddEmailMutation();
  const [setPrimary] = useAccountsControllerSetPrimaryMutation();
  const [remove] = useAccountsControllerRemoveMutation();

  console.log({ data });

  const handleSubmit: ReformSubmitHandler<AccountDto> = async (
    formData,
    setError: ReformSetError,
  ) => {
    await addEmail(formData)
      .unwrap()
      .then(() => {
        gtag('event', 'add-email', { user: profile.id });
      })
      .catch((error) => errorHandler(error, setError));
  };

  const handleSetPrimary: ActionButtonHandler<AccountDto> = async (actionData) => {
    await setPrimary({ ...actionData }).then(() => {
      gtag('event', 'set-primary-email', { user: profile.id });
    });

    //new Promise((res) => setTimeout(res, 2000));
  };

  const handleRemove: ActionButtonHandler<AccountDto> = async (verifyData) => {
    gtag('event', 'change-password', { user: profile.id });

    await remove({ ...verifyData }).then(() => {
      gtag('event', 'remove-email', { user: profile.id });
    });
  };

  return (
    <div className='flex flex-col h-full items-stretch dark:text-white'>
      <div className='grow-0 text-xl font-bold'>
        <h2>{t('Change Email')}</h2>
      </div>
      <div className='grow pt-4 pb-10 px-1 -mx-1 overflow-y-auto'>
        <div className='flex flex-col min-w-fit md:w-1/2'>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {/*<pre>{JSON.stringify(data, null, 2)}</pre>*/}
              <table className='w-full table-fixed'>
                <thead>
                  <tr className='text-xs font-semibold border-b dark:border-[#FFDA68]/30'>
                    <td className='hidden sm:table-cell'>{t('Email')}</td>
                    <td className='hidden lg:table-cell text-center'>{t('Is Primary')}</td>
                    <td className='hidden lg:table-cell text-center'>{t('Is Verified')}</td>
                    <td className='hidden lg:table-cell text-right'>{t('Actions')}</td>
                  </tr>
                </thead>
                <tbody className='text-sm lg:text-base divide-y divide-gray-100 dark:divide-[#FFDA68]'>
                  {data?.map((i, k) => (
                    <tr key={k}>
                      <td className='py-2 text-sm'>{i.identity}</td>
                      <td className='text-center'>
                        {!k ? <div className='badge badge-green'>{t('Primary')}</div> : '-'}
                      </td>
                      <td className='text-center'>
                        {i.isVerified ? (
                          <span className='badge badge-green'>
                            <i className='icon-ok' /> {t('Verified')}
                          </span>
                        ) : (
                          <span className='badge badge-red'>{t('Unverified')}</span>
                        )}
                      </td>
                      <td className='space-x-1 text-right'>
                        {!i.isVerified && (
                          <Link
                            className='button button-xs '
                            to={`/settings/account/email/${btoa(encodeURIComponent(i.identity))}`}
                          >
                            <Trans
                              i18nKey='Verify <i/>'
                              components={{
                                i: <i className='icon-ok' />,
                              }}
                            />
                          </Link>
                        )}

                        {!!k && (
                          <ActionButton
                            data-provider={i.provider}
                            data-identity={i.identity}
                            onClick={handleRemove}
                            className='button button-xs button-red'
                          >
                            <i className='icon-delete' />
                          </ActionButton>
                        )}

                        {!!k && (
                          <ActionButton
                            className='button button-xs button-yellow'
                            data-provider={i.provider}
                            data-identity={i.identity}
                            onClick={handleSetPrimary}
                          >
                            <i className='icon-check' />
                          </ActionButton>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Form onSubmit={handleSubmit} className='mt-4'>
                <div>
                  <Input
                    name='identity'
                    placeholder={t('New Email')}
                    className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
                  />
                  <Input name='provider' value='email' type='hidden' />
                </div>
                <ErrorArea />
                <div>
                  <button
                    type='submit'
                    className='w-full font-semibold text-sm bg-blue-500 h-11 rounded-lg dark:bg-[#FFDA68] dark:text-[#151515]'
                  >
                    {t('Add')}
                  </button>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
